import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const removeGroupBillingDivision = payload =>
  call(websocketFetch, 'remove_group_billing_division', payload);
